export default __webpack_public_path__ + "static/media/search.7b4c268e.png";